export default __webpack_public_path__ + "static/media/Ogg-Regular.d93035ce.woff2";